import { ListItem, ListItemButton, ListItemIcon } from "@mui/material";
import { LISTITEM_ICON_WIDTH, StyledListItemText } from "./MainMenuWithoutLink";
import { useLocation } from "react-router-dom";

type SubMenuWithLinkProps = {
  handleSubMenuWithLinkOnClick: () => void;
  children: JSX.Element;
  menuName: string;
  pathName: string;
};

const SubMenuWithLink = ({
  handleSubMenuWithLinkOnClick,
  children,
  menuName,
  pathName,
}: SubMenuWithLinkProps) => {
  const location = useLocation();
  return (
    <ListItem
      disablePadding
      onClick={handleSubMenuWithLinkOnClick}
      key={menuName}
      sx={{ color: "white", "&.active": { backgroundColor: "#4eca0c" } }}
      className={location.pathname === pathName ? "active" : ""}
    >
      <ListItemButton sx={{ pl: 6, pt: "4px", pb: "4px" }}>
        <ListItemIcon sx={{ color: "inherit", minWidth: LISTITEM_ICON_WIDTH }}>
          {children}
        </ListItemIcon>
        <StyledListItemText primary={menuName} />
      </ListItemButton>
    </ListItem>
  );
};

export default SubMenuWithLink;
